/**
 * Admin reducer
 *
 * @author Anh Tu Le <anh.le@vertics.co>
 *
 * @copyright Vertics Co 2019
 */
import {} from './../actions'
const initialState = {
    properties: [],
    selectedProperty: null,
    users: [],
    selectedUser: null,
    loading: false,
    error: null
}
export const adminReducer = (state = initialState, action) => {
    switch (action.type) {
       
                default:
                    return state
    }
}
export const adminSelectors = {
    getPublished: (state = initialState) => state.published,
    getLoading: (state = initialState) => state.loading,
    getError: (state = initialState) => state.error
}